import { render, staticRenderFns } from "./formStep4.vue?vue&type=template&id=c98ff33a&"
import script from "./formStep4.vue?vue&type=script&lang=js&"
export * from "./formStep4.vue?vue&type=script&lang=js&"
import style0 from "./formStep4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports